module.exports = __webpack_public_path__ + "static/erich-f0987f2a94c63bdd4d664b641272e96f.png";